import { Text, Card } from '@/components'
import { Gift, DollarSign } from 'react-feather'
import { RewardRow } from './RewardRow'
import { Transaction } from '@/types/transaction'
import TransactionDisplayModal from '../components/transactionDisplayModal'
import { ActivityViewModelProps } from './Activity.viewmodel'
import { pointsToDollars } from '../../rewards.utils'
import { IconContainer } from '../components/IconContainer'
import clsx from 'clsx'

export const CompletedTransactionsCard = (props: ActivityViewModelProps) => {
  if (!props.completedTransactions.length) return null

  const completedTransactions = props.completedTransactions.slice(
    0,
    props.loadedTransactions,
  )

  const getProps = (transaction: Transaction) => {
    switch (transaction.type) {
      case 'referral':
        return {
          icon: (
            <IconContainer
              icon={Gift}
              bgColor="bg-purple-100"
              textColor="text-purple-700"
            />
          ),
          label: 'Invitation Bonus',
          description: 'For inviting a friend',
        }
      case 'redeem':
        return {
          icon: (
            <IconContainer
              icon={DollarSign}
              bgColor="bg-green-100"
              textColor="text-green-700"
            />
          ),
          label: 'Reward redemption',
          description: 'Complete',
        }
      case 'program_referral':
        return {
          icon: (
            <IconContainer
              icon={Gift}
              bgColor="bg-purple-100"
              textColor="text-purple-700"
            />
          ),
          label: 'Program Referral',
          description: 'For inviting a friend to a utility program',
        }
      case 'reward_program':
        return {
          icon: (
            <IconContainer
              icon={Gift}
              bgColor="bg-purple-100"
              textColor="text-purple-700"
            />
          ),
          label: 'Program Reward',
          description: 'For participating in a utility program',
        }
      case 'reward_program_signup':
        return {
          icon: (
            <IconContainer
              icon={Gift}
              bgColor="bg-purple-100"
              textColor="text-purple-700"
            />
          ),
          label: 'Program Sign-Up',
          description: 'For joining a utility program',
        }
      default:
        return {}
    }
  }

  return (
    <Card className="w-full">
      <div className="w-full flex justify-start flex-col">
        <Text variant="h3">Completed</Text>
        <div className="w-full flex flex-col items-center divide-y divide-solid divide-gray-200">
          {completedTransactions?.map((transaction) => (
            <RewardRow
              icon={
                <IconContainer
                  icon={DollarSign}
                  bgColor="bg-green-100"
                  textColor="text-green-700"
                />
              }
              label="Reward Redemption"
              description={`($${pointsToDollars(
                Math.abs(transaction.points),
              )})`}
              key={transaction.id}
              onClick={() => props.setTransactionToDisplay(transaction)}
              label2={
                <Text
                  className={clsx(
                    `text-sm font-bold`,
                    {
                      'text-green-700': transaction.points < 0,
                    },
                    'whitespace-nowrap',
                  )}
                >
                  {transaction.points < 0 ? '-$' : '+$'}
                  {pointsToDollars(Math.abs(transaction.points))}
                </Text>
              }
              {...getProps(transaction)}
            />
          ))}
          {props.loadedTransactions < props.completedTransactions.length && (
            <div
              onClick={props.loadMore}
              className="w-full text-center pt-5 cursor-pointer"
            >
              <Text className="text-sm font-medium text-blue-600">
                Load More
              </Text>
            </div>
          )}
        </div>
        <TransactionDisplayModal
          transaction={props.transactionToDisplay}
          onClose={() => props.setTransactionToDisplay(null)}
        />
      </div>
    </Card>
  )
}
